import ButtonMultiClick from "@/components/Buttons/ButtonMultiClick";
import styles from "@/styles/Video.module.scss";
import { useCallback } from "react";

export default function ResumeSelect({ state }) {
  const handleContinue = useCallback(() => {
    state.updateResumePoint(state.playbackAuth.resumePoint);
  }, []);
  const handleFirst = useCallback(() => {
    state.updateResumePoint(0);
  }, []);

  return (
    <div className={styles.resume}>
      <div className={styles.buttons}>
        <ButtonMultiClick fillColor medium onClick={handleContinue}>
          続きから再生
        </ButtonMultiClick>
        <ButtonMultiClick fillColor medium onClick={handleFirst}>
          最初から再生
        </ButtonMultiClick>
      </div>
    </div>
  );
}
